import { required, Validator } from '@/entities/validation';
import { Gateway } from './model';

export const validate: Validator<Gateway> = gateway => [
  ...required(gateway.title, 'title'),
  ...required(gateway.entityItem ? gateway.entityItem.toString() : '', 'entityItem'),
];
